module.exports = __webpack_public_path__ + "static/media/ashwin.9e3183b0.jpeg";